// extracted by mini-css-extract-plugin
module.exports = {"hero":"moters-diena_hero__5sbmL","paper":"moters-diena_paper__gnSWy","heroWrap":"moters-diena_heroWrap__a_6pd","heroImg":"moters-diena_heroImg__3rSTq"};